'use strict';
$(document).ready(function () {
    new Swiper('#mega-menu-drop', {
        slidesPerView: 1.3,
        spaceBetween: 30,
        navigation: {
            nextEl: ".swiper-button-next-model",
            prevEl: ".swiper-button-prev-model"
        },
        breakpoints: {
            1024: {
                slidesPerView: 2.3,
                spaceBetween: 30
            },
            1170: {
                slidesPerView: 4,
                spaceBetween: 48
            }
        }
    });
    $('.btn-signin-header').click(function () {
        $('#btn-signin').click();
    });
    $('.mega-menu-btn').click(function () {
        $('.mega-menu').toggleClass('show-menu');
    });
    $('.mega-menu').click(function (e) {
        if (e.target === this) {
            $(this).removeClass('show-menu');
        }
    });
    $('.mega-menu-header svg').click(function () {
        $('.mega-menu').removeClass('show-menu');
    });
});
